const NewsCategoryIndex = () => import('./views/NewsCategoryIndex.vue')
const NewsCategoryCreate = () => import('./views/NewsCategoryCreate.vue')
const NewsCategoryEdit = () => import('./views/NewsCategoryEdit.vue')

export default [
  {
    path: 'news/categories',
    name: 'news.categories.index',
    component: NewsCategoryIndex
  },
  {
    path: 'news/categories/create',
    name: 'news.categories.create',
    component: NewsCategoryCreate
  },
  {
    path: 'news/categories/:categoryId(\\d+)',
    name: 'news.categories.edit',
    component: NewsCategoryEdit
  }
]
